import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { useContext } from 'react';

import fortress from '../api/fortress';
import { AuthContext } from '../contexts/AuthContext';
import { BrandContext } from '../contexts/BrandContext';
import { useGlobalStore } from '../store/store';

interface IResponse {
  latest_date: string;
  previous_date: string;
  previous_subscriptions_change: number;
  previous_subscriptions_change_pct: number;
  previous_wk8_units_change: number;
  previous_wk8_units_change_pct: number;
  pt_subscriptions: string;
  pt_wk8_units: string;
  subscriptions: string;
  wk8_units: string;
}

export const useSummarySNS = () => {
  const { token } = useContext(AuthContext);
  const { brand } = useContext(BrandContext);
  const { dates, currency, marketplaces } = useGlobalStore();
  const params = {
    brandid: brand.brandId,
    tf_s: format(dates.tf_s, 'yyyy-MM-dd'),
    tf_e: format(dates.tf_e, 'yyyy-MM-dd'),
    wow: 'daily',
    currency: currency,
    marketplace: marketplaces,
  };

  return useQuery({
    queryKey: ['SummarySNS', params, token],
    queryFn: () => {
      return fortress.get<IResponse>('brand/data/summarySNS', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
    },
    // enabled: false,
    throwOnError: () => {
      return false;
    },
  });
};
